/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, imageTypes, replacePXinStringWithEM, color } from 'utils/styles';



// ===================== ANIMATION : QUESTION ===================== //
const aniQuestionInitial = {
    // ~~~~~~~~~~~~~~~~~~~~~ INITIAL STATE ~~~~~~~~~~~~~~~~~~~~~ //
    '& .question': {
        
    }
};



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export { aniQuestionInitial };